/* eslint-disable react-hooks/exhaustive-deps */

import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useManageTable } from "hooks";
import { GetListRequestParams } from "libs/api";

import { useGetProductBoxesList } from "../apis";

const useProductBoxesList = (productVariantId?: string) => {
  const { page, debouncedSearch, sorting, setSorting, setPage } =
    useManageTable();

  const requestParams: GetListRequestParams = {
    page,
    take: GET_LIST_REQUEST_DEFAULT_LIMIT,
    search: debouncedSearch,
    orderBy: sorting[0]?.id,
    order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "DESC"
  };

  const {
    boxesItemsList,
    meta,
    isLoading,
    refetch: refetchDamagedItems
  } = useGetProductBoxesList(requestParams, productVariantId);

  return {
    boxesItemsList,
    totalItems: meta?.itemCount ?? 0,
    page,
    isLoading,
    sorting,
    setSorting,
    setPage,
    refetchDamagedItems
  };
};

export default useProductBoxesList;
